import makeStyles from '@mui/styles/makeStyles';
import { type Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '55px',
    [theme.breakpoints.down(1100)]: {
      marginBottom: '40px',
    },
    [theme.breakpoints.down(600)]: {
      marginTop: '40px',
      marginBottom: '32px',
    },
  },
  title: {
    marginBottom: '10px',
    textAlign: 'center',
    [theme.breakpoints.down(600)]: {
      lineHeight: '30px',
    },
  },
  description: {
    marginBottom: '25px',
    textAlign: 'center',
    fontSize: '14px',
    fontWeight: 400,
    [theme.breakpoints.down(600)]: {
      lineHeight: '20px',
    },
  },
  button: {
    width: '187px',
    marginBottom: '10px',
  },
  info: {
    fontSize: '12px',
    fontWeight: 400,
  },
  link: {
    marginLeft: '3px',
  },
}));
